export default function(update) {
  return new Array(update.length);
}



//////////////////
// WEBPACK FOOTER
// ./~/d3/~/d3-selection/src/selection/sparse.js
// module id = UKrg
// module chunks = 0